import { FormControlLabel, Switch } from '@material-ui/core';
import React from 'react'

const Approval = ({ config, draft, setDraft }) => {
  const onChange = (key, value) => setDraft({ ...draft, [key]: value });

  return (
    <div>
      <FormControlLabel
        control={<Switch
          defaultChecked={config.needSupervisorApproval}
          checked={draft.needSupervisorApproval}
          onChange={(e) => onChange('needSupervisorApproval', e.target.checked)}
          name="needSupervisorApproval" />
        }
        label="Approval SPV"
      />
      {/* <FormControlLabel
        control={<Switch checked={state.checkedA} onChange={handleChange} name="checkedA" />}
        label="Editable"
      /> */}
    </div>
  )
}

export default Approval
